import { AuthContext } from '@/contexts/AuthContext';
import { use } from 'react';

export function useAuth() {
  const context = use(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}
